import { render, staticRenderFns } from "./RidershipDashboardModule.vue?vue&type=template&id=4a44a683&scoped=true"
import script from "./RidershipDashboardModule.vue?vue&type=script&lang=js"
export * from "./RidershipDashboardModule.vue?vue&type=script&lang=js"
import style0 from "./RidershipDashboardModule.vue?vue&type=style&index=0&id=4a44a683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a44a683",
  null
  
)

export default component.exports